import {$t, $tc} from "@/i18n";
import DialogModule from "../../store/modules/dialog";
import SalesInvoiceModule from "../../store/modules/sales_invoice";
import {isRef} from "@vue/composition-api";
import errorDialog from "@/views/ErrorDialog/errorDialog"

export default function (account_id, selected_invoices, callback) {
    if (!isRef(selected_invoices)) console.error("Invoice export :: selected invoices must be referenced");
    let invoice_id_list = [];
    const {getExportableInvoices, exportSalesInvoices} = SalesInvoiceModule();
    const {setConfirmOptions, openConfirmDialog} = DialogModule();
    const onConfirm = async () => {
        if (invoice_id_list.length < 1) return errorDialog.showError($t('These invoices cannot be exported. Check their status or error messages.'))
        exportSalesInvoices(account_id, invoice_id_list)
            .then(function () {
                for (const invoice of Array.from(selected_invoices.value)) {
                    if (Array.from(invoice_id_list).includes(invoice.id)) {
                        invoice.process_status = "export_invoice";
                    }
                }
                if (callback) callback();
            })
            .catch(ex => errorDialog.showError(ex));
    };
    const onExportInvoicesClick = () => {
        account_id = account_id ? account_id : selected_invoices.value[0].account_id;

        const exportableInvoices = getExportableInvoices(selected_invoices.value)
        invoice_id_list = exportableInvoices.map(invoice => invoice.id);

        const title = $tc("Exporting invoice | Exporting invoices", invoice_id_list.length)
            + (invoice_id_list.length >= 2 ? " (" + invoice_id_list.length + ")" : "");

        const text = $tc(
            "You are about to export this invoice to accounting. | You are about to export these invoices to accounting.",
            invoice_id_list.length
        ) + " " + $t("Please confirm that you wish to proceed.");

        const invoicesContainExportedInvoice = exportableInvoices.find(x => x.exported_at)
        let warningText = null
        if (invoicesContainExportedInvoice) {
            warningText = $tc(
                "This invoice has already been exported. Are you sure you want to export it as a new invoice? | Some of these invoices have already been exported. Are you sure that you want to export them as new invoices?",
                invoice_id_list.length
            )
        }
        setConfirmOptions({title, text, confirm_text: $t("Continue"), cancel_text: $t("Cancel"), action: onConfirm, warning_text: warningText});
        openConfirmDialog();
    };
    return {onExportInvoicesClick};
};
